import { Fragment } from 'react'

import quantumComputing from 'assets/img/home/upcoming-programs-5.jpg'
import ai from 'assets/img/courses/ai.jpg'

import semesterQuantumComputing from 'assets/img/courses/quantum-computing.jpg'
import semesterAI from 'assets/img/home/upcoming-programs-1-new.jpg'

export const emergingTech = {
  sectionData: {
    sectionId: 'techCourses',
    sectionHeading: (
      <Fragment>
        Our Emerging{' '}
        <span className="text-animated">
          <span>Tech Courses</span>
        </span>
      </Fragment>
    ),
    sectionDescription: (
      <Fragment>
        Accredited by WASC & partnered with the DoD STEM, Google Quantum AI, AWS, IBM Quantum, Stanford, Johns Hopkins & more, we offer the most <span className="text-bold text-italic text-blue-gradient">supportive, in-depth & engaging</span> tech education for K-12 & beyond.
      </Fragment>
    ),
  },
  coursesData: [
    {
      sectionTitle: 'Academic year courses',
      cards: [
        {
          isInverted: false,
          cardImg: quantumComputing,
          cardTitle: 'Introduction to Quantum Computing',
          cardSubtitle: (
            <Fragment>
              Semesters I & II
              <span className="d-block">Grades 9 - 12 & Above</span>
              <span className="d-block">September 2024 - April 2025</span>
            </Fragment>
          ),
          keyPoints: [
            'Be among the first students in the world to learn quantum computing',
            'Learn in-depth skills applying quantum computing',
            'Discover the magic of quantum hardware',
            'Meet renown quantum experts',
            'Go on virtual quantum lab tours',
            'Run code on a quantum computer!',
          ],
          button: [
            {
              external: true,
              text: 'Learn more',
              link: 'https://www.qubitbyqubit.org/course-info',
            },
            {
              external: true,
              text: 'Interest Form',
              link: 'https://airtable.com/appdS9n7K25uof6m4/shrk9rCX4MuD6T0HY',
            },
          ],
        },
        {
          isInverted: true,
          cardImg: ai,
          cardTitle: 'Introduction to Artificial Intelligence',
          cardSubtitle: (
            <Fragment>
              Semesters I & II
              <span className="d-block">Grades: 9 - 12</span>
              <span className="d-block">September 2024 - April 2025</span>
            </Fragment>
          ),
          keyPoints: [
            'For-credit course',
            'Develop advanced skills in AI',
            'Hands-on applications with ML algorithms such as KNN and k-means clustering',
            'Gain skills in computer vision, natural language processing, and deep learning',
            'Create AI capstone project',
          ],
          button: [
            {
              external: false,
              text: 'Learn more',
              link: '/train-course',
            },
            {
              external: true,
              text: 'Interest Form',
              link: 'https://airtable.com/appdS9n7K25uof6m4/shrk9rCX4MuD6T0HY',
            },
          ],
        },
      ],
    },
    {
      sectionTitle: 'Semester Courses',
      cards: [
        {
          isInverted: false,
          cardImg: semesterQuantumComputing,
          cardTitle: 'Foundations of Quantum Computing',
          cardSubtitle: (
            <Fragment>
              Semester I of Introduction to Quantum Computing
              <span className="d-block">Grades 9 - 12 & Above</span>
              <span className="d-block">September - December 2025</span>
            </Fragment>
          ),
          keyPoints: [
            'Explore the world of quantum ',
            'Learn foundational skills in quantum mechanics',
            'using qubits, superpositon and entanglement concepts',
            'Discuss ethics and biases to use quantum responsibly',
            'Develop Python skills',
            'Options to continue on to Semester II',
          ],
          button: [
            {
              external: true,
              text: 'Learn more',
              link: 'https://www.qubitbyqubit.org/semester-course-info',
            },
            {
              external: true,
              text: 'Interest Form',
              link: 'https://airtable.com/appdS9n7K25uof6m4/shrk9rCX4MuD6T0HY',
            },
          ],
        },
        {
          isInverted: true,
          cardImg: semesterAI,
          cardTitle: 'Foundations of Data Science & Machine Learning',
          cardSubtitle: (
            <Fragment>
              Semester I of Introduction to Artificial Intelligence
              <span className="d-block">Grades: 9 - 12</span>
              <span className="d-block">September - December 2025</span>
            </Fragment>
          ),
          keyPoints: [
            'Develop foundational data science skills ',
            'Create visualizations & ML models',
            'Learn Responsible AI',
            'Industry expert Q&As',
            'Gain skills in Python',
            'Options to continue on to Semester II',
          ],
          button: [
            {
              external: false,
              text: 'Learn more',
              link: '/train-semester-course',
            },
            {
              external: true,
              text: 'Interest Form',
              link: 'https://airtable.com/appdS9n7K25uof6m4/shrk9rCX4MuD6T0HY',
            },
          ],
        },
      ],
    }
  ],
  nonTabCoursesData: [
    {
      isInverted: false,
      cardImg: quantumComputing,
      cardTitle: 'Introduction to Quantum Computing',
      cardSubtitle: (
        <Fragment>
          Workshops, Bootcamps, &amp; Intensives
          <span className="d-block">High school, University, &amp; Workforce</span>
        </Fragment>
      ),
      keyPoints: [
        'Be among the first students in the world to learn quantum computing',
        'Learn foundational skills in quantum computing',
        'Discover the magic of quantum hardware',
        'Meet renown quantum experts',
        'Go on virtual quantum lab tours',
        'Run code on a quantum computer!',
      ],
      button: [
        {
          external: true,
          text: 'Learn more',
          link: 'https://www.qubitbyqubit.org/course-info',
        },
        {
          external: true,
          text: 'Interest Form',
          link: 'https://airtable.com/appdS9n7K25uof6m4/shrk9rCX4MuD6T0HY',
        },
      ],
    },
    {
      isInverted: true,
      cardImg: semesterAI,
      cardTitle: 'Introduction to Artificial Intelligence',
      cardSubtitle: (
        <Fragment>
          Workshops, Bootcamps, &amp; Intensives
          <span className="d-block">High school students</span>
        </Fragment>
      ),
      keyPoints: [
        'Develop foundational skills in AI',
        'Create visualizations & ML Models',
        'Hands-on applications with ML algorithms such as KNN and k-means clustering',
        'Gain skills in computer vision, natural language processing, and deep learning',
        'Learn Responsible AI',
      ],
      button: [
        {
          external: false,
          text: 'Learn more',
          link: '/train-course',
        },
        {
          external: true,
          text: 'Interest Form',
          link: 'https://airtable.com/appdS9n7K25uof6m4/shrk9rCX4MuD6T0HY',
        },
      ],
    },
  ]
}
